import React from 'react';
import { useTranslation } from 'react-i18next';

export function ProtectedRoute({ children, user, requiredRole }) {
  const { t } = useTranslation();
  // Check if user is authenticated
  if (!user) {
    return (
      <div
        data-testid="protected-route-no-user-main"
        className="min-h-screen flex items-center justify-center bg-gray-100"
      >
        <div
          data-testid="protected-route-no-user-card"
          className="bg-white p-8 rounded-lg shadow-md text-center"
        >
          <h2
            data-testid="protected-route-no-user-title"
            className="text-2xl font-bold text-red-600 mb-4"
          >
            {t('protected.accessDeniedTitle')}
          </h2>
          <p data-testid="protected-route-no-user-message" className="text-gray-600">
            {t('protected.mustBeLoggedIn')}
          </p>
        </div>
      </div>
    );
  }

  // Check if user has required role (case-insensitive comparison)
  if (requiredRole && user.role?.toLowerCase() !== requiredRole?.toLowerCase()) {
    return (
      <div
        data-testid="protected-route-wrong-role-main"
        className="min-h-screen flex items-center justify-center bg-gray-100"
      >
        <div
          data-testid="protected-route-wrong-role-card"
          className="bg-white p-8 rounded-lg shadow-md text-center"
        >
          <h2
            data-testid="protected-route-wrong-role-title"
            className="text-2xl font-bold text-red-600 mb-4"
          >
            {t('protected.accessDeniedTitle')}
          </h2>
          <p data-testid="protected-route-wrong-role-message" className="text-gray-600">
            {t('protected.noPermission')}
          </p>
          <p data-testid="protected-route-wrong-role-roles" className="text-sm text-gray-500 mt-2">
            {t('protected.requiredRole', { requiredRole, userRole: user.role })}
          </p>
        </div>
      </div>
    );
  }

  // User is authenticated and has correct role
  return <>{children}</>;
}

export function withProtection(Component, requiredRole) {
  return function ProtectedComponent(props) {
    return (
      <ProtectedRoute user={props.user} requiredRole={requiredRole}>
        <Component {...props} />
      </ProtectedRoute>
    );
  };
}
